<div [formGroup]="form" (keydown.enter)="onSubmit ()">
    <ngb-alert [ngStyle]="{ 'visibility': 'hidden' }" [type]="'danger'" ></ngb-alert>
    <div class="mb-3 mb-2">
        <textarea class='form-control ' rows='10' disabled="disabled">{{ banner () }}</textarea>
    </div> 
    <footer-submit-cancel #foot (submit)="onSubmit ()"  (cancel)="onCancel ()"></footer-submit-cancel>
    
  </div>